import { withRouter } from 'react-router';
import { compose, withProps, branch } from 'recompose';
import { equals, find, pipe, prop, propOr } from 'ramda';

import { getNextLink } from '../helpers';
import { generateUrlString } from '../../utils/helpers';
import WithGiftCardUrlPattern from '../../hoc/WithGiftCardUrlPattern';
import WithShops from '../../hoc/WithShops';

const getGcSalesShop = find(
  pipe(
    prop('customerGiftCardEnabled'),
    equals(true),
  ),
);

const getBrandId = pipe(
  find(
    pipe(
      prop('brandId'),
      Boolean,
      equals(true),
    ),
  ),
  propOr(null, 'brandId'),
);

const withBrandGiftCardLink = compose(
  WithGiftCardUrlPattern,
  WithShops,
  withProps((props) => {
    const shop = getGcSalesShop(props.shops);
    const brand = getBrandId(props.shops);
    if (!shop || !brand) {
      return { link: null };
    }

    const params = { shopRoute: shop.route };
    return {
      link: getNextLink(
        params,
        () => generateUrlString(params, props.urlPattern),
        false,
        brand,
      ),
    };
  }),
);

const withGiftCardLink = compose(
  WithGiftCardUrlPattern,
  withRouter,
  withProps(props => ({
    link: getNextLink(
      props.params,
      () => generateUrlString(props.params, props.urlPattern),
      false,
    ),
  })),
);

export default branch(
  props => props.withBrand,
  withBrandGiftCardLink,
  withGiftCardLink,
);



// WEBPACK FOOTER //
// ./src/app/giftCard/hoc/withGiftCardLink.js